// Spreadsheet apps run a cell starting with = + - @ (or tab/CR) as a formula.
// Filter labels and values come from the scanned site's own HTML, so a hostile
// page could plant one in an export. Prefixing an apostrophe makes Excel,
// Sheets and LibreOffice show it as text (OWASP's CSV-injection guidance).
export function csvSafe(value) {
  if (typeof value !== "string") return value;
  return /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
}
